import styles from './Badge.module.css';
import { classList } from '../../helpers/classList';

export type BadgeTone =
  'neutral' | 'info' | 'notice' | 'pending' | 'active' | 'attention' | 'warning' | 'error' | 'success';

export interface BadgeProps {
  tone?: BadgeTone;
  className?: string;
  title?: string;
  children?: React.ReactNode;
}

export const Badge = ({ tone = 'neutral', className, title, children }: BadgeProps) => (
  <span className={classList(styles.badge, styles[tone], className)} title={title}>
    {children}
  </span>
);
